import React from 'react';
import { useMediaQuery } from 'react-responsive';
import PricingContent from './PricingContent';

const Desktop = ({ children }) => {
  const isDesktop = useMediaQuery({ minWidth: 768 });
  return isDesktop ? children : null;
};

const DesktopResponsive = ({ history }) => (
  <Desktop>
    <PricingContent history={history} />
  </Desktop>
);

export default DesktopResponsive;
